import { TotalDonationSection } from './TotalDonationSection'
import { withTotalDonationSection } from './withTotalDonationSection'

const ConnectedTotalDonationSection =
  withTotalDonationSection(TotalDonationSection)
export { ConnectedTotalDonationSection as TotalDonationSection }
